<template>
  <div class="mask">
    <div class="score-box">
      <div class="title">
        <p class="title-text">答题结果</p>
        <img class="icon-close" src="../../assets/images/icons/icon-close.png" alt="" @click="closeBox">
      </div>
      <div class="score-content">
        <div class="score-content-copywriting">
          <div class="total-score">
            <p>总得分</p>
            <div class="score">
              <div class="show-score">
                <span class="my-score">{{scoreInfo.totalScore}}</span>
                <span class="total-number">/{{scoreInfo.paperScore}}分</span>
              </div>
            </div>
          </div>
          <div class="copywriting-r">
            <div class="course-name-box">
              <p class="label">课程名称</p>
              <p class="name">{{scoreInfo.courseName}}</p>
            </div>
            <div class="stimulate">
              <p class="label">请您继续加油!</p>
              <p class="content">想要通过考试，建议配合课程听老师分析讲解，再加强试题练习，<br/>从备考冲刺快速锁分，让备考更高效</p>
            </div>
          </div>
        </div>
        <div class="score-content-table">
          <el-table
            :header-cell-style="{background:'#F9F9F9',color:'#999999', height: '43px;'}"
            :data="scoreInfo.list"
            style="width: 100%">
            <el-table-column
              prop="learnClass"
              class-name="sroce-table-td-color-23C086"
              align="center"
              label="已学习（节）"
              width="180">
            </el-table-column>
            <el-table-column
              prop="timelong"
              class-name="sroce-table-td-color-23C086"
              align="center"
              label="听课时长"
              width="180">
            </el-table-column>
            <el-table-column
              class-name="sroce-table-td-color-23C086"
              prop="ranking"
              align="center"
              label="排名">
            </el-table-column>
            <el-table-column
              class-name="sroce-table-td-color-23C086"
              prop="accuracy"
              align="center"
              label="正确率">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      courseName: this.$route.query.name
    }
  },
  computed: {
    scoreInfo() {
      return this.$store.state.questions.scoreInfo;
    },
  },
  watch: {

  },
  methods: {
    closeBox() {
      this.$store.commit('questions/IS_SHOW_SCORE');
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/css/style.scss';
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5)
  }
  .score-box {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 760px;
    height: 530px;
    background: #FFFFFF;
    border-radius: 4px;
    .title {
      @include  flex-between-and-vertical-center();
      height: 54px;
      border-bottom: 1px solid #F0F0F0;
      padding: 0 20px;
      .title-text {
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
        @include flex-vertical-center();
        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 20px;
          background-color: $color-primary;
          margin-right: 8px;
        }
      }
      .icon-close {
        width: 20px;
        cursor: pointer;
      }
    }
    .score-content {
      padding: 0 30px;
    }
    .score-content-copywriting {
      @include flex();
      padding: 15px 0 20px 0;
      border-bottom: 1px solid #F0F0F0;
      margin-bottom: 20px;
      .total-score {
        width: 187px;
        font-size: 14px;
        text-align: center;
        .score {
          width: 120px;
          height: 120px;
          line-height: 120px;
          background-color: $color-primary;
          border-radius: 100px;
          
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          margin: 9px auto 0 auto;
          .show-score {
            position: relative;
            display: inline-block;
            .my-score {
              font-size: 38px;
            }
            .total-number {
              font-size: 14px;
            }
          }
        }
      }
      .copywriting-r {
        flex: 1;
      }
      .course-name-box {
        margin-bottom: 19px;
        border-bottom: 1px solid #F0F0F0;
        .label {
          font-size: 14px;
          color: #999999;
          margin-bottom: 9px;
        }
        .name {
          font-weight: 500;
          margin-bottom: 14px;
        }
      }
      .stimulate {
        font-size: 14px;
        .content {
          color: #999999;
          line-height: 20px;
          margin-top: 6px;
        }
      }
    }
  }
</style>
<style lang="scss">
  .sroce-table-td-color-23C086 {
    color: #23C086;
  }
  .sroce-table-td-color-red {
    color: #F94D48;
  }
  .sroce-table-td-color-333333 {
    color: #333333;
  }
</style>




// WEBPACK FOOTER //
// src/components/questions/score.vue